import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PdfService } from '../../../core/services/pdf.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'p2f-print-preview',
  templateUrl: './print-preview.component.html',
  styleUrls: ['./print-preview.component.scss']
})

export class PrintPreviewComponent implements OnInit {
  link;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { pages: number[], isSelectAll: boolean },
    private pdfService: PdfService,
    private sanitizer: DomSanitizer,
    private translate: TranslateService,
    private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.loadPdf();
  }

  loadPdf(): void {
   this.showPrintMessage();
    this.pdfService.printDocument(this.data.pages, this.data.isSelectAll).subscribe(response => {
      const file = new Blob([response], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      this.link = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
    });
  }

  showPrintMessage(): void{
    this.translate.get('print-message').subscribe(response => {
      const config = new MatSnackBarConfig();
      config.duration = 5000;
      config.panelClass = ['custom-snackbar'];
      config.horizontalPosition = 'right';
      config.verticalPosition = 'top';
      this.snackBar.open(response, "x", config);
    });
  }

}

